// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.advisor-home-container {
  padding: 50px 10px 0px 70px;
}
.advisor-home-container .advisor-details-container {
  border: 1px solid white;
  border-radius: 4px;
  padding: 10px;
}
.advisor-home-container .advisor-details-container .advisor-details {
  padding: 5px;
  border-radius: 4px;
  margin-bottom: 14px;
  text-align: center;
}
.advisor-home-container .advisor-details-container .advisor-details .accordion-title {
  border-radius: 4px;
  text-align: center;
  padding: 5px;
  color: #000;
}
.advisor-home-container .advisor-details-container .advisor-details .accordion-title .MuiTypography-root {
  font-size: 16px;
  font-weight: 600;
}
.advisor-home-container .select-plans-container {
  border: 1px solid white;
  border-radius: 4px;
  min-height: 50vh;
  width: 100%;
  margin: 0 0 10px 0;
}
.advisor-home-container .anchor-line {
  border-top: 1px solid white;
  opacity: 1;
}
.advisor-home-container .goto-dashboard-button {
  padding-top: 30px !important;
}
.advisor-home-container .goto-dashboard-button button {
  background-color: #009fe3;
  padding: 4px;
  border-radius: 8px;
  height: 25px;
  color: white;
  font-size: 12px;
}
.advisor-home-container .goto-dashboard-button button .MuiButton-startIcon {
  margin: 0;
}
.advisor-home-container .goto-dashboard-button button .MuiButton-iconSizeMedium {
  margin-right: 0;
}
.advisor-home-container .status-title {
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  text-transform: uppercase;
  margin-bottom: 20px;
}
.advisor-home-container .notes-container .status-list-container {
  border: 1px solid white;
  border-radius: 12px;
  padding: 8px 20px 2px 20px;
  margin: 20px 0px 10px 20px;
  width: 300px;
}
.advisor-home-container .notes-container .notes-section .MuiTextField-root input::placeholder {
  font-size: 10px;
}
.advisor-home-container .notes-container .notes-section .MuiTextField-root .MuiOutlinedInput-root {
  border: 1px solid #00a19a !important;
  box-sizing: border-box;
  border-radius: 13px;
}
.advisor-home-container .notes-container .notes-section .MuiTextField-root fieldset {
  border: none;
}
.advisor-home-container .notes-container .notes-section .MuiTextField-root {
  width: 100%;
  background: linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0) 357.5%);
  border: 1px solid #ffffff;
  box-sizing: border-box;
  border-radius: 13px;
}
.advisor-home-container .notes-container .notes-section .MuiInputBase-input {
  padding: 8px 0;
}
.advisor-home-container .notes-container .notes-section .text-container {
  margin-top: 10px;
  width: 100%;
  position: relative;
}
.advisor-home-container .notes-container .notes-section .text-container .text-icon {
  position: absolute;
  right: 0;
  bottom: 0;
  padding: 10px 10px 5px 10px;
}
.advisor-home-container .notes-container .notes-section .text-container .text-icon button {
  border: none;
  background: none;
  color: #009fe3;
  cursor: pointer;
}
.advisor-home-container .notes-container .notes-section .text-container textarea {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  background: linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0) 357.5%);
  border: 1px solid #ffffff;
  box-sizing: border-box;
  border-radius: 13px;
  resize: none;
  width: 100%;
  padding: 8px 12px;
}
.advisor-home-container .notes-container .notes-section .text-container textarea::placeholder {
  font-size: 10px;
}
.advisor-home-container .notes-container .notes-section .comment-box {
  font-style: normal;
  font-weight: normal;
  font-size: 10px;
  background-color: white;
  box-shadow: 0px 0px 34px rgba(0, 0, 0, 0.02);
  border-radius: 10px;
  border-radius: 8px;
  margin-top: 8px;
  padding: 10px;
  justify-content: space-between;
}
.advisor-home-container .notes-container .notes-section .comment-box > div {
  display: flex;
  justify-content: space-between;
}
.advisor-home-container .notes-container .notes-section .comment-box > div:nth-child(2) {
  margin-bottom: 10px;
}
.advisor-home-container .notes-container .notes-section .comment-box p {
  margin: 0;
  word-break: break-all;
}
.advisor-home-container .notes-container .notes-section .comment-box .delete-icon button {
  border: none;
  background: none;
  color: #ffffff;
  cursor: pointer;
}
.advisor-home-container .notes-container .notes-section .notes-section-div {
  min-height: 385px;
  max-height: 450px;
  overflow: auto;
  padding-right: 8px;
}
.advisor-home-container .notes-container .notes-section .search-comments-container {
  padding-top: 20px;
}
.advisor-home-container .dashboard-summary-container {
  border: 1px solid #ffffff;
  box-sizing: border-box;
  box-shadow: -5px 4px 34px rgba(85, 85, 85, 0.04);
  border-radius: 10px;
  margin: 15px 0px 0px 0px;
  padding: 5px;
}
.advisor-home-container .dashboard-summary-container .MuiAccordion-root {
  position: relative;
}
.advisor-home-container .dashboard-summary-container .MuiAccordionSummary-expandIconWrapper {
  position: absolute;
  left: 10px;
}
.advisor-home-container .dashboard-summary-container .MuiAccordionSummary-content {
  margin: 0 0 0 18px;
}
.advisor-home-container .dashboard-summary-container .dashboard-market .dashboard-input {
  border-radius: 8px;
  border: 0.5px solid #61b76e;
  width: 100%;
  height: 30px;
  padding: 4px;
}
.advisor-home-container .dashboard-summary-container .dashboard-market .dashboard-input:focus-visible {
  outline: none;
}
.advisor-home-container .dashboard-summary-container .dashboard-market .dashboard-input-hide {
  opacity: 0;
  height: 0;
  width: 0;
}
.advisor-home-container .dashboard-summary-container .dashboard-market .dashboard-input-show {
  opacity: 1;
  transition: all 0.3s ease-out;
  -webkit-transition: all 0.3s ease-out;
}
.advisor-home-container .dashboard-summary-container .dashboard-market .dashboard-input-show svg {
  vertical-align: middle;
}
.advisor-home-container .dashboard-summary-container .dashboard-market .dashboard-input-show .select {
  width: 80%;
  border-color: #61b76e;
  border-radius: 8px;
  padding: 4px 0;
  font-size: 12px;
}
.advisor-home-container .dashboard-summary-container .dashboard-market .dashboard-input-show .select option {
  font-size: 12px;
}
.advisor-home-container .dashboard-summary-container .dashboard-market .dashboard-input .MuiInput-underline:before {
  border-bottom: none;
}
.advisor-home-container .dashboard-summary-container .dashboard-market .dashboard-input .MuiInput-underline:after {
  border-bottom: none;
}
.advisor-home-container .dashboard-summary-container .dashboard-market .dashboard-input .MuiInput-underline:hover {
  border-bottom: none;
}
.advisor-home-container .dashboard-summary-container .dashboard-market .dashboard-input .MuiInput-underline:hover:not(.Mui-disabled):before {
  border-bottom: none;
}`, "",{"version":3,"sources":["webpack://./src/styles/advisorhome.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;AACF;AAAE;EACE,uBAAA;EACA,kBAAA;EACA,aAAA;AAEJ;AAAI;EACE,YAAA;EAEA,kBAAA;EACA,mBAAA;EACA,kBAAA;AACN;AAAM;EAKE,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AAFR;AALQ;EACE,eAAA;EACA,gBAAA;AAOV;AAEE;EACE,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AAAJ;AAEE;EACE,2BAAA;EACA,UAAA;AAAJ;AAEE;EACE,4BAAA;AAAJ;AACI;EACE,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AACN;AAAM;EACE,SAAA;AAER;AAAM;EACE,eAAA;AAER;AAEE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EAEA,mBAAA;AADJ;AAII;EACE,uBAAA;EACA,mBAAA;EACA,0BAAA;EACA,0BAAA;EACA,YAAA;AAFN;AAQQ;EACE,eAAA;AANV;AAQQ;EACE,oCAAA;EACA,sBAAA;EACA,mBAAA;AANV;AAQQ;EACE,YAAA;AANV;AASM;EACE,WAAA;EACA,8EAAA;EAKA,yBAAA;EACA,sBAAA;EACA,mBAAA;AAXR;AAaM;EACE,cAAA;AAXR;AAaM;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;AAXR;AAaQ;EAOE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,2BAAA;AAjBV;AAQU;EACE,YAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AANZ;AAaQ;EAIE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,8EAAA;EAKA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;AAlBV;AACU;EACE,eAAA;AACZ;AAkBM;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;EAIA,uBAAA;EACA,4CAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;AAnBR;AAoBQ;EACE,aAAA;EACA,8BAAA;AAlBV;AAoBQ;EACE,mBAAA;AAlBV;AAoBQ;EACE,SAAA;EACA,qBAAA;AAlBV;AAqBU;EACE,YAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAnBZ;AAuBM;EACE,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AArBR;AAuBM;EACE,iBAAA;AArBR;AAyBE;EACE,yBAAA;EACA,sBAAA;EACA,gDAAA;EACA,mBAAA;EACA,wBAAA;EACA,YAAA;AAvBJ;AAwBI;EACE,kBAAA;AAtBN;AAwBI;EACE,kBAAA;EACA,UAAA;AAtBN;AAwBI;EACE,kBAAA;AAtBN;AA0BQ;EACE,kBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAxBV;AA0BU;EACE,aAAA;AAxBZ;AA0BU;EACE,UAAA;EACA,SAAA;EACA,QAAA;AAxBZ;AA0BU;EACE,UAAA;EAEA,6BAAA;EACA,qCAAA;AAzBZ;AA2BY;EACE,sBAAA;AAzBd;AA2BY;EACE,UAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAzBd;AA0Bc;EACE,eAAA;AAxBhB;AA6BU;EACE,mBAAA;AA3BZ;AA6BU;EACE,mBAAA;AA3BZ;AA6BU;EACE,mBAAA;AA3BZ;AA6BU;EACE,mBAAA;AA3BZ","sourcesContent":[".advisor-home-container {\r\n  padding: 50px 10px 0px 70px;\r\n  .advisor-details-container {\r\n    border: 1px solid #ffff;\r\n    border-radius: 4px;\r\n    padding: 10px;\r\n\r\n    .advisor-details {\r\n      padding: 5px;\r\n      // border: 1px solid #ffff;\r\n      border-radius: 4px;\r\n      margin-bottom: 14px;\r\n      text-align: center;\r\n      .accordion-title {\r\n        .MuiTypography-root {\r\n          font-size: 16px;\r\n          font-weight: 600;\r\n        }\r\n        border-radius: 4px;\r\n        text-align: center;\r\n        padding: 5px;\r\n        color: #000;\r\n      }\r\n    }\r\n  }\r\n  .select-plans-container {\r\n    border: 1px solid #ffff;\r\n    border-radius: 4px;\r\n    min-height: 50vh;\r\n    width: 100%;\r\n    margin: 0 0 10px 0;\r\n  }\r\n  .anchor-line {\r\n    border-top: 1px solid #ffff;\r\n    opacity: 1;\r\n  }\r\n  .goto-dashboard-button {\r\n    padding-top: 30px !important;\r\n    button {\r\n      background-color: #009fe3;\r\n      padding: 4px;\r\n      border-radius: 8px;\r\n      height: 25px;\r\n      color: #ffff;\r\n      font-size: 12px;\r\n      .MuiButton-startIcon {\r\n        margin: 0;\r\n      }\r\n      .MuiButton-iconSizeMedium {\r\n        margin-right: 0;\r\n      }\r\n    }\r\n  }\r\n  .status-title {\r\n    font-style: normal;\r\n    font-weight: 600;\r\n    font-size: 14px;\r\n    line-height: 21px;\r\n    text-transform: uppercase;\r\n    // color: #ffffff;\r\n    margin-bottom: 20px;\r\n  }\r\n  .notes-container {\r\n    .status-list-container {\r\n      border: 1px solid white;\r\n      border-radius: 12px;\r\n      padding: 8px 20px 2px 20px;\r\n      margin: 20px 0px 10px 20px;\r\n      width: 300px;\r\n    }\r\n\r\n    .notes-section {\r\n      // padding: 5px;\r\n      .MuiTextField-root {\r\n        input::placeholder {\r\n          font-size: 10px;\r\n        }\r\n        .MuiOutlinedInput-root {\r\n          border: 1px solid #00a19a !important;\r\n          box-sizing: border-box;\r\n          border-radius: 13px;\r\n        }\r\n        fieldset {\r\n          border: none;\r\n        }\r\n      }\r\n      .MuiTextField-root {\r\n        width: 100%;\r\n        background: linear-gradient(\r\n          180deg,\r\n          #ffffff 0%,\r\n          rgba(255, 255, 255, 0) 357.5%\r\n        );\r\n        border: 1px solid #ffffff;\r\n        box-sizing: border-box;\r\n        border-radius: 13px;\r\n      }\r\n      .MuiInputBase-input {\r\n        padding: 8px 0;\r\n      }\r\n      .text-container {\r\n        margin-top: 10px;\r\n        width: 100%;\r\n        position: relative;\r\n\r\n        .text-icon {\r\n          button {\r\n            border: none;\r\n            background: none;\r\n            color: #009fe3;\r\n            cursor: pointer;\r\n          }\r\n          position: absolute;\r\n          right: 0;\r\n          bottom: 0;\r\n          padding: 10px 10px 5px 10px;\r\n        }\r\n        textarea {\r\n          &::placeholder {\r\n            font-size: 10px;\r\n          }\r\n          font-style: normal;\r\n          font-weight: normal;\r\n          font-size: 14px;\r\n          line-height: 24px;\r\n          background: linear-gradient(\r\n            180deg,\r\n            #ffffff 0%,\r\n            rgba(255, 255, 255, 0) 357.5%\r\n          );\r\n          border: 1px solid #ffffff;\r\n          box-sizing: border-box;\r\n          border-radius: 13px;\r\n          resize: none;\r\n          width: 100%;\r\n          padding: 8px 12px;\r\n        }\r\n      }\r\n      .comment-box {\r\n        font-style: normal;\r\n        font-weight: normal;\r\n        font-size: 10px;\r\n        // color: #ffffff;\r\n        // width: 230px;\r\n        // background: rgba(255, 255, 255, 0.3);\r\n        background-color: white;\r\n        box-shadow: 0px 0px 34px rgba(0, 0, 0, 0.02);\r\n        border-radius: 10px;\r\n        border-radius: 8px;\r\n        margin-top: 8px;\r\n        padding: 10px;\r\n        justify-content: space-between;\r\n        & > div {\r\n          display: flex;\r\n          justify-content: space-between;\r\n        }\r\n        & > div:nth-child(2) {\r\n          margin-bottom: 10px;\r\n        }\r\n        p {\r\n          margin: 0;\r\n          word-break: break-all;\r\n        }\r\n        .delete-icon {\r\n          button {\r\n            border: none;\r\n            background: none;\r\n            color: #ffffff;\r\n            cursor: pointer;\r\n          }\r\n        }\r\n      }\r\n      .notes-section-div {\r\n        min-height: 385px;\r\n        max-height: 450px;\r\n        overflow: auto;\r\n        padding-right: 8px;\r\n      }\r\n      .search-comments-container {\r\n        padding-top: 20px;\r\n      }\r\n    }\r\n  }\r\n  .dashboard-summary-container {\r\n    border: 1px solid #ffffff;\r\n    box-sizing: border-box;\r\n    box-shadow: -5px 4px 34px rgb(85 85 85 / 4%);\r\n    border-radius: 10px;\r\n    margin: 15px 0px 0px 0px;\r\n    padding: 5px;\r\n    .MuiAccordion-root {\r\n      position: relative;\r\n    }\r\n    .MuiAccordionSummary-expandIconWrapper {\r\n      position: absolute;\r\n      left: 10px;\r\n    }\r\n    .MuiAccordionSummary-content {\r\n      margin: 0 0 0 18px;\r\n    }\r\n    .dashboard-market {\r\n      .dashboard {\r\n        &-input {\r\n          border-radius: 8px;\r\n          border: 0.5px solid #61b76e;\r\n          width: 100%;\r\n          height: 30px;\r\n          padding: 4px;\r\n\r\n          &:focus-visible {\r\n            outline: none;\r\n          }\r\n          &-hide {\r\n            opacity: 0;\r\n            height: 0;\r\n            width: 0;\r\n          }\r\n          &-show {\r\n            opacity: 1;\r\n            // max-height: 100%;\r\n            transition: all 0.3s ease-out;\r\n            -webkit-transition: all 0.3s ease-out;\r\n            // padding-top: 8px;\r\n            svg {\r\n              vertical-align: middle;\r\n            }\r\n            .select {\r\n              width: 80%;\r\n              border-color: #61b76e;\r\n              border-radius: 8px;\r\n              padding: 4px 0;\r\n              font-size: 12px;\r\n              option {\r\n                font-size: 12px;\r\n              }\r\n            }\r\n          }\r\n          //for date picker\r\n          .MuiInput-underline:before {\r\n            border-bottom: none;\r\n          }\r\n          .MuiInput-underline:after {\r\n            border-bottom: none;\r\n          }\r\n          .MuiInput-underline:hover {\r\n            border-bottom: none;\r\n          }\r\n          .MuiInput-underline:hover:not(.Mui-disabled):before {\r\n            border-bottom: none;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
